export function Johto(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      {}
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      >
        <path
          strokeLinejoin="round"
          d="M22 12c-2.4 0-4.333-1.333-5-2H7c-.667.667-2.6 2-5 2l.17.342A3 3 0 0 0 4.855 14h14.292a3 3 0 0 0 2.683-1.658zm-3-8c-1.453 0-2.735-.489-3.668-1.022c-.984-.563-1.476-.844-1.728-.911C13.35 2 13.015 2 12.344 2h-.687c-.672 0-1.008 0-1.26.067c-.253.067-.745.348-1.729.91C7.735 3.512 6.453 4 5 4l.17.342A3 3 0 0 0 7.855 6h8.292a3 3 0 0 0 2.683-1.658z"
        />
        <path d="M17 10V6M7 10V6m12 16v-8M5 22v-8m-2 8h18m-11 0v-3a2 2 0 1 1 4 0v3" />
      </g>
    </svg>
  );
}
